import { Outlet } from "react-router-dom"
import Header from "../components/layout/Header"
import MobileHeader from "../components/layout/MobileHeader"
import Footer from "../components/layout/Footer"


function Main() {
    return (
      <>
        <div class="body-wrapper">  

            <Header/>  

            <MobileHeader/>  
    
            <div class="ltn__utilize-overlay"></div>
    
            <Outlet />
    
            <Footer />

        </div>
  
        <div class="preloader d-none" id="preloader">
            <div class="preloader-inner">
                <div class="spinner">
                    <div class="dot1"></div>
                    <div class="dot2"></div>
                </div>
            </div>
        </div>


        

      </>
    );
  }
  
  export default Main;
  